import { createSlice } from '@reduxjs/toolkit'
import {getFactoryAdvanceOptions} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';
import { getContract, getContractByCaseId } from '../contract/thunks';

const initialState= { 
  advance: {
    node: "",
    options: []
  }, 
  loading: "idle",
  error: null }

const factoryAdvanceOptionsSlice = createSlice({
  name: 'factoryAdvanceOptions',
  initialState,
  extraReducers: {
    [getFactoryAdvanceOptions.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
      },
    [getFactoryAdvanceOptions.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      state.advance = action.payload
    },
    [getFactoryAdvanceOptions.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
      },
    [getContractByCaseId.fulfilled]:()=> initialState,
    [getContract.fulfilled]:()=> initialState,
    [logOut]: (state)=> initialState
  }
})

export default factoryAdvanceOptionsSlice.reducer
